import React from 'react';
import { Item, Button } from 'semantic-ui-react';

import PassengerDropdown from './PassengerDropdown';
import SelectedPassengerLabels from './SelectedPassengerLabels';

const View = ({
  id,
  flightId,
  affiliate,
  claimCrmState,
  selectedPassengers,
  isAddPassengerVisible,
  onSavePassengers,
  onPassengerDelete,
  onAddPassengerOpen,
  onSearchPassengers,
  onPassengerSelect,
  data: { allClaimStates }
}) => (
  <Item.Group>
    <Item>
      <SelectedPassengerLabels
        selectedPassengers={selectedPassengers}
        onPassengerDelete={onPassengerDelete}
      />
      <Item.Content>
        <Button
          primary
          size="mini"
          floated="right"
          icon={isAddPassengerVisible ? 'save' : 'plus'}
          name="Passenger"
          labelPosition="left"
          className="c-TicketDetails__add-btn"
          content={isAddPassengerVisible ? 'Save' : 'Add Passenger'}
          onClick={
            isAddPassengerVisible ? onSavePassengers : onAddPassengerOpen
          }
        />
      </Item.Content>
    </Item>
    {isAddPassengerVisible && (
      <Item>
        <Item.Content>
          <Item.Header>Add Passenger</Item.Header>
          <PassengerDropdown
            id={id}
            flightId={flightId}
            affiliate={affiliate}
            claimCrmState={claimCrmState}
            allClaimStates={allClaimStates}
            onSearchChange={onSearchPassengers}
            onPassengerSelect={onPassengerSelect}
          />
        </Item.Content>
      </Item>
    )}
  </Item.Group>
);

export default View;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Passengers/AddPassenger/View.js